module.exports = __webpack_public_path__ + "img/baharain-2.25fbbfa4.png";